import { Field, Int, ObjectType } from '@nestjs/graphql'
import { ArcPagedResultDto } from './pagedResult.dto'

@ObjectType()
export class ArcEligibleGroupResultDto {
  @Field(t => Int)
  authorTeamCount!: number

  @Field(t => Int)
  allCount!: number

  @Field(t => Int)
  savedCount!: number

  @Field(t => ArcPagedResultDto)
  result!: ArcPagedResultDto
}
